<div class="app-toggle-track"
     [ngStyle]="{
       'background': !!trueValueColour && !!value ? trueValueColour : (!!falseValueColour && !value ? falseValueColour : ''),
       'border-color': !!trueValueColour && !!value ? trueValueColour : (!!falseValueColour && !value ? falseValueColour : '')
     }">
  <div class="app-toggle-icon"></div>
</div>
